// removed by extract-text-webpack-plugin
module.exports = {"InformationFormsContainer":"_2Fuw4MCnDyyIUMUoxZ89a2","InformationFormsWrapper":"_9wY9e1fE7wfN0kT-dYfm_","ToogleItem":"_3YDurpC3VjK2FWAM_Bl95Q","ToogleItemActive":"_1iRv2ici3kz2E4JuaUV_pA"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Forms/ToogleInput/style.css
// module id = 1401
// module chunks = 0